namespace $ {

	export function $mol_offline( ) {}

}
